import React, { useState } from "react";
import { OverlayContactHost } from "../OverlayContactHost";
import { Button } from "../Button";
import { IPropertyResult, ContentType } from "@/interfaces/property";
import { getContent } from "@/lib/reactutils";
import { _ } from "@/lib/i18n";
import { resolvePropertyDetailAction } from "./resolvePropertyDetailAction";

export const PropertyButtonsMain: React.FC<{property: IPropertyResult}> = ({
  property
}) => {
  const [showContactOverlay, setShowContactOverlay] = useState(false);

  if(!property || property.details.length === 0) return;

  const mainButtons = property.details.filter(detail => detail.size === "large");
  if(mainButtons.length === 0) return;

  const handleMessageHost = () => {
    setShowContactOverlay(true);
  };

  const closeOverlay = () => {
    setShowContactOverlay(false);
  };

  const buttons = [].concat(mainButtons).sort((a,b) => a.order - b.order).map((button, index) => {
    const buttonKey = button.order + index; // Added to fix console error `key` is not a prop in Button

    const action = resolvePropertyDetailAction(button.type, property.coordinates);

    switch (action?.kind) {
      case "directions":
        return (
          <Button key={buttonKey} type="overlay"
            buttonKey = {buttonKey}
            image="/assets/img/propertyButtonDirections.svg?placeholderIfAbsent=true"
            button={button.name}
            overlayParagraphs={getContent(ContentType.BUTTON, button.contents)}
            paragraphWithCopyButton={{
              paragraph: (
                <>
                  <p className="font-bold">Address:</p>
                  <p>{property.address}</p>
                </>
              ),
              copyValue: property.address
            }}
            buttons={[{
              text: "Open in Google Maps",
              bgColor: "bg-accent",
              buttonExtraClasses: "justify-center",
              onClick: () => {
                window.open(action.googleMapsUrl, "_blank");
              }
            }]}
          />
        );
      case "contact":
        return (
          <Button key={buttonKey} type="function"
            buttonKey={buttonKey}
            image="/assets/img/propertyButtonContactHost.svg?placeholderIfAbsent=true"
            button={_("contact_host") + property.profile.name} onClick={handleMessageHost}/>
        );
      case "overlay":
        return (
          <Button key={buttonKey} type="overlay"
            buttonKey={buttonKey}
            button={button.name}
            overlayParagraphs={getContent(ContentType.BUTTON, button.contents)}
          />
        );
      default:
        return null;
    }
  });



  return (
    <>
      <div className="grid grid-cols-1 w-full gap-[12px]">
        {buttons}
      </div>

      {showContactOverlay && (
        <OverlayContactHost isOpen={showContactOverlay} onClose={closeOverlay}
          hostPhoneNumber={property.contact}  />
      )}
    </>
  );
};